import { render, staticRenderFns } from "./CsTarifariosTarifasAdicionales.vue?vue&type=template&id=66fe38a2"
import script from "./CsTarifariosTarifasAdicionales.vue?vue&type=script&lang=js"
export * from "./CsTarifariosTarifasAdicionales.vue?vue&type=script&lang=js"
import style0 from "./CsTarifariosTarifasAdicionales.vue?vue&type=style&index=0&id=66fe38a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports